import React from 'react';
import styled from 'styled-components/macro';
import { useIntl } from 'react-intl';
import { Gallery } from 'src/client/components/splash/Straplez/Gallery';
import { useSelector } from 'src/client/redux/modules/helpers/useSelector';
import { SplashGalleryResponse } from 'src/@types/Splash';
import { spriteUrl, useGetGalleryCoverUrl } from 'src/client/helpers/urls';
import { useShowSfwSite } from 'src/client/helpers/useFeatureFlags';
import { CoverAttributes } from 'src/client/helpers/urls/useGetGalleryCoverUrl';

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-left: -15px;

  @media (max-width: 1024px) {
    margin-left: 0;
  }

  .GALLERY {
    max-width: 19%;
    @media (max-width: 768px) {
      max-width: 23%;
    }

    @media (max-width: 430px) {
      max-width: 95%;
    }
  }

  .MOVIE {
    max-width: 32%;
    @media (max-width: 768px) {
      max-width: 32%;
    }

    @media (max-width: 430px) {
      max-width: 95%;
    }
  }
`;

type Props = {
  updates: SplashGalleryResponse[];
  coverAttributes: CoverAttributes;
  updatesMax: number;
};

export const GalleryUpdates = (props: Props) => {
  const intl = useIntl();
  const { contentCdnUrl } = useSelector((state) => state.app);
  const { updates, coverAttributes, updatesMax } = props;

  const config = useSelector((state) => state.app.config);
  const showSfwSite = useShowSfwSite();
  const getGalleryCoverUrl = useGetGalleryCoverUrl();

  const showPreview = config.featureFlags?.showMoviePreview;

  if (!updates.length) {
    return null;
  }

  return (
    <Div>
      {updates.slice(0, updatesMax).map((gallery) => {
        const { type, name, publishedAt, models, path, imageCount, runtime } = gallery;
        const { url, blurImage } = getGalleryCoverUrl(contentCdnUrl, gallery, coverAttributes);

        const isMovie = gallery.type.toLowerCase() === 'movie';
        const isNetworkWideGallery = gallery.isStaffSelection || gallery.isIntimateSelection;
        const itemSpriteUrl =
          isMovie && showPreview && !isNetworkWideGallery && !showSfwSite
            ? spriteUrl(gallery, contentCdnUrl, gallery.siteUUID, true)
            : null;

        const published = intl.formatDate(new Date(publishedAt), { year: 'numeric', month: 'long', day: '2-digit' });

        return (
          <Gallery
            blurImage={blurImage}
            galleryCoverUrl={url}
            galleryUrl={path}
            imageCount={imageCount}
            key={gallery.UUID}
            models={models.map((model) => model.name).join(', ')}
            publishedAt={published}
            runtime={runtime}
            spriteUrl={itemSpriteUrl}
            title={name}
            type={type}
          />
        );
      })}
    </Div>
  );
};
